import { Box, Icon } from '@palmetto/palmetto-components';
import { Link } from 'react-router-dom';

import { HOLD_QUEUE_PATH } from './HoldMotionTabs';

const STEPS = [
  { id: 'filter-program', content: <>Filter to the program type you want to turn off</> },
  {
    id: 'release-in-batches',
    content: (
      <span>
        Release held projects in batches until the held count reaches <strong>0</strong>
      </span>
    ),
  },
  {
    id: 'toggle-off',
    content: (
      <span>
        Return here and toggle Hold Motion <strong>off</strong>
      </span>
    ),
  },
];

const StepNumber = ({ value }: { value: number }) => (
  <Box
    background="grey-900"
    color="white"
    radius="sm"
    fontSize="xs"
    fontWeight="bold"
    width="24px"
    height="24px"
    alignItems="center"
    justifyContent="center"
    flexShrink="0"
  >
    {value}
  </Box>
);

export const HoldQueueDrainCallout = () => {
  return (
    <Box background="primary-50" radius="md" padding="lg" gap="md">
      <Box direction="row" gap="sm" alignItems="center" fontWeight="bold">
        <Icon name="c-info" size="lg" />
        Turning a program off releases its held projects
      </Box>
      <Box display="block">
        Toggling Hold Motion <strong>off</strong> immediately releases every currently held project for that program
        into the payout batching pipeline. To avoid a large uncontrolled release, drain the queue first:
      </Box>
      <Box gap="sm">
        <Box direction="row" gap="md" alignItems="center">
          <StepNumber value={1} />
          <Box direction="row" gap="xs" alignItems="center">
            Open the
            <Link to={HOLD_QUEUE_PATH} target="_blank" rel="noopener noreferrer">
              <strong>Hold Queue</strong>
            </Link>
            <Icon name="launch-app" size="sm" />
          </Box>
        </Box>
        {STEPS.map((step, index) => (
          <Box key={step.id} direction="row" gap="md" alignItems="center">
            <StepNumber value={index + 2} />
            {step.content}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
